"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckInput = exports.StyledIndeterminateIcon = exports.StyledCheckIcon = exports.StyledCheckWrapper = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledCheckWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 32px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  ", "\n"], ["\n  display: flex;\n  width: 32px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  ",
    "\n"])), function (_a) {
    var disabled = _a.disabled;
    return !disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n        }\n        &:focus {\n          background-color: ", ";\n        }\n        &:active {\n          background-color: ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n        }\n        &:focus {\n          background-color: ", ";\n        }\n        &:active {\n          background-color: ", ";\n        }\n      "])), theme_1.colors.green50, theme_1.colors.green50, theme_1.colors.green100);
});
exports.StyledCheckIcon = styled_components_1.default.span({
    backgroundColor: theme_1.colors.transparent,
    borderColor: theme_1.colors.grey700,
    borderStyle: 'solid',
    borderWidth: '2px',
    borderRadius: '1px',
    boxSizing: 'border-box',
    display: 'inline-block',
    height: '18px',
    outline: 'none',
    position: 'relative',
    transition: 'background .1s linear',
    width: '18px',
    boxShadow: 'none !important',
});
exports.StyledIndeterminateIcon = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: transparent;\n  height: 24px;\n  width: 24px;\n  transition: background .1s linear;\n\n  .ap-icon {\n    fill: ", ";\n  }\n"], ["\n  background-color: transparent;\n  height: 24px;\n  width: 24px;\n  transition: background .1s linear;\n\n  .ap-icon {\n    fill: ", ";\n  }\n"])), theme_1.colors.grey700);
exports.StyledCheckInput = styled_components_1.default.input((_a = {},
    _a["+ " + exports.StyledCheckIcon] = (_b = {},
        _b['.ap-icon'] = {
            display: 'none',
        },
        _b),
    _a[":checked + " + exports.StyledCheckIcon] = (_c = {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            borderWidth: 0,
            height: '24px',
            width: '24px'
        },
        _c['.ap-icon'] = {
            display: 'block',
            fill: theme_1.colors.grey700,
        },
        _c),
    _a[":disabled + " + exports.StyledCheckIcon] = (_d = {
            backgroundColor: theme_1.colors.white,
            borderColor: theme_1.colors.grey300,
            cursor: 'not-allowed'
        },
        _d['.ap-icon'] = {
            fill: theme_1.colors.grey300,
        },
        _d),
    _a[":disabled + " + exports.StyledIndeterminateIcon] = (_e = {
            cursor: 'not-allowed'
        },
        _e['.ap-icon'] = {
            fill: theme_1.colors.grey300,
        },
        _e),
    _a.display = 'none',
    _a));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map